import { createSlice } from '@reduxjs/toolkit';
import { IAccount } from 'common/accounts.interface';

export interface BankingState {
  accounts: IAccount[];
  balances: { accountId: number; accountType: string; total: number }[];
}

const initialState: BankingState = {
  accounts: [],
  balances: [],
};

const bankingSlice = createSlice({
  name: 'banking',
  initialState,
  reducers: {
    setAccounts: (state: BankingState, action) => {
      state.accounts = action.payload;
    },
    setBalances: (state: BankingState, action) => {
      state.balances = action.payload;
    },
  },
});

export const { setAccounts, setBalances } = bankingSlice.actions;
export default bankingSlice.reducer;
